(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('policyRuleSection', ["path", function (path) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('policy-rules/policy-rule-section').template('policy-rule-section'),
            transclude: true,
            scope: { title: '@policyRuleSection' },
            link: function ($scope, element, attrs) {
                var contentArea = element.find('.section-content');
                contentArea.hide();
                var hidden = true;
                var moving = false;
                $scope.toggleSection = function () {
                    if (moving) {
                        return;
                    }
                    if (hidden) {
                        moving = true;
                        element.addClass('opened');
                        contentArea.slideDown().promise().done(function () {
                            moving = false;
                        });
                        hidden = false;
                    } else {
                        moving = true;
                        element.removeClass('opened');
                        contentArea.slideUp().promise().done(function () {
                            moving = false;
                        });
                        hidden = true;
                    }
                };
            }
        };
    }]);
}());